import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Crops, typeCrop} from '@entities/canh-tac/canh-tac.model';

import {HttpResponse} from '@angular/common/http';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import saveAs from 'file-saver';
import * as moment from 'moment';
import {CanhTacService} from '@entities/canh-tac/canh-tac.service';
@Component({
  selector: 'app-canh-tac-exportfile-dialog',
  templateUrl: './canh-tac-exportfile-dialog.component.html',
})
export class CanhTacExportfileDialogComponent implements OnInit {
  minDate: Date;
  maxDate: Date;
  check: boolean;
  startDate: Date;
  endDate: Date;
  lo: Crops;
  isSaving: boolean;

  constructor(
    private dialogRef: MatDialogRef<CanhTacExportfileDialogComponent>,
    private titleService: Title,
    private translate: TranslateService,
    private canhTacService: CanhTacService,
  ) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear);
    this.maxDate = new Date();
    this.check = true;
    this.lo = new Crops();
    this.isSaving = false;
  }

  ngOnInit() {
    if (this.lo.id !== null) {
      this.titleService.setTitle(
        this.translate.instant(
          'entities.canh-tac.canh-tac-exportfile-dialog.Xuất báo cáo_title',
        ),
      );
    }
  }

  startDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.minDate = new Date(event.value);
    this.minDate.setDate(this.minDate.getDate());
    this.startDate = this.minDate;
    this.check = false;
  }

  endDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.endDate = new Date(event.value);
    // this.maxDate = this.endDate;
  }

  save() {
    if (this.startDate && this.endDate && this.lo.id !== null) {
      const param = {
        startDate: moment(this.startDate).format('DD-MM-YYYY'),
        endDate: moment(this.endDate).format('DD-MM-YYYY'),
      };
      if (this.lo.tbCropTypeId === typeCrop.UOM) {
        this.canhTacService.exportUom(this.lo.id, param).subscribe(
          (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
          () => this.onSaveError(),
        );
      } else if (this.lo.tbCropTypeId === typeCrop.TRONG) {
        this.canhTacService.exportTrong(this.lo.id, param).subscribe(
          (resp: HttpResponse<Blob>) => this.onSaveSuccess(resp),
          () => this.onSaveError(),
        );
      }
    }
  }
  private onSaveSuccess(result) {
    const contentDisposition = result.headers.get('content-disposition');
    const filename = contentDisposition
      .split(';')[1]
      .split('filename')[1]
      .split('=')[1]
      .trim();
    if (filename) {
      saveAs(result.body, filename);
    } else {
      alert(' Không tìm thấy filename');
    }
    this.isSaving = false;
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-canhtac-exportfile',
  template: '',
})
export class CanhTacExportFilePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<CanhTacExportfileDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({lo}) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(CanhTacExportfileDialogComponent, {
          disableClose: true,
          width: '400px',
        });
        if (lo !== undefined) {
          this.dialogRef.componentInstance.lo = lo;
        }

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.canh-tac.canh-tac-exportfile-dialog.Danh sách lô_title',
      ),
    );
  }
}
